export const ADDON_ADD_ITEM = 'ADDON_ADD_ITEM';
export const ADDON_REMOVE_ITEM = 'ADDON_REMOVE_ITEM';
export const ADD_ADDIN_ADDON = 'ADD_ADDIN_ADDON';
export const REMOVE_ADDIN_ADDON = 'REMOVE_ADDIN_ADDON';
export const ADDON_EMPTY = 'ADDON_EMPTY';

